import { classNames } from "../../../../lib/class-names";
import "./card-default.scss";

type CardDefaultPropsT = {
  children: React.ReactNode;
  type: "primary" | "dark" | "light" | "grey" | "dark-grey";
  cardNumber?: number;
  borderColor?: string;
  width?: "fit-content" | "full-width";
  clickable?: boolean;
};

const CardDefault = ({
  children,
  type,
  cardNumber,
  borderColor,
  width = "fit-content",
  clickable,
}: CardDefaultPropsT) => {
  const cardClasses = classNames({
    "card-default": true,
    "card-default--primary": type === "primary",
    "card-default--dark": type === "dark",
    "card-default--light": type === "light",
    "card-default--grey": type === "grey",
    "card-default--dark-grey": type === "dark-grey",
    "card-default--number-margin": !!cardNumber,
    "card-default--fit-content": width === "fit-content",
    "card-default--full-width": width === "full-width",
    "card-default--clickable": !!clickable,
  });

  return (
    <div
      className={cardClasses}
      style={borderColor ? { border: `1px solid ${borderColor}` } : {}}
    >
      {cardNumber && <div className="card-default__number">{cardNumber}</div>}
      {children}
    </div>
  );
};

export default CardDefault;
